import * as React from "react";
import { AppInsightsService } from "../services/AppInsightsService";
import { MEMBERS_PORTAL } from "../../accounts/Consts";

interface IPageViewTrackerProps {
    location: any;
    portalType: string;
}

const getRouteGroup = (pathname: string, portalType: string): string => {
    if (!pathname || pathname === "/") {
        return "/";
    }

    const segments = pathname.split("/").filter(Boolean);

    if (segments.length === 0) {
        return "/";
    }

    if (portalType === MEMBERS_PORTAL) {
        return `/${segments[0]}`;
    }

    if (segments.length >= 2) {
        return `/${segments[0]}/${segments[1]}`;
    }

    return `/${segments[0]}`;
};

export const PageViewTracker: React.FC<IPageViewTrackerProps> = ({ location, portalType }) => {
    React.useEffect(() => {
        if (!AppInsightsService.appInsights) {
            return;
        }

        if (!location.pathname || location.pathname === "/") {
            return;
        }

        const name = getRouteGroup(location.pathname, portalType);
        const uri = window.location.href;

        AppInsightsService.trackPageView(name, uri, {
            portalType,
        });

    }, [location.pathname, location.search, location.hash, portalType]);

    return null;
};